import useForceUpdate from "PFCore/helpers/use_force_update";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "../overwrites.module.scss";
import SkillsRow from "./skills_row";

const Skills = ({ skills, exportableProfile, cfName }) => {
  const { t } = useTranslation();
  const categorisedSkills = skills[0];
  const otherSkills = skills[1];
  const categories = Object.keys(categorisedSkills);
  const deselectedSkills = exportableProfile.getUnselectedSkills();
  const forceUpdate = useForceUpdate();
  return (
    <div className={css.skillsWrapper}>
      <div className={css.skillsTitle}>{t("skills")}</div>
      {categories.map((name, index) => (
        <SkillsRow
          key={index}
          name={name}
          collection={categorisedSkills[name]}
          exportableProfile={exportableProfile}
          cfName={cfName}
          deselectedSkills={deselectedSkills}
          forceUpdate={forceUpdate}
        />
      ))}
      {otherSkills.length > 0 && (
        <SkillsRow
          name="Other skills"
          collection={otherSkills}
          exportableProfile={exportableProfile}
          cfName={cfName}
          deselectedSkills={deselectedSkills}
          forceUpdate={forceUpdate}
        />
      )}
    </div>
  );
};

Skills.propTypes = {
  skills: PropTypes.array,
  exportableProfile: PropTypes.object,
  cfName: PropTypes.string
};

export default Skills;
